// Generated by ReScript, PLEASE EDIT WITH CARE

import * as V2$Linear from "./V2.res.js";

function fill(v) {
  return V2$Linear.fill(V2$Linear.fill(v));
}

function map(mat, f) {
  return V2$Linear.map(mat, __x => V2$Linear.map(__x, f));
}

function transpose(param) {
  let match = param[1];
  let match$1 = param[0];
  return [
    [
      match$1[0],
      match[0]
    ],
    [
      match$1[1],
      match[1]
    ]
  ];
}

function jsonCodec(elementCodec) {
  return V2$Linear.jsonCodec(V2$Linear.jsonCodec(elementCodec));
}

export {
  fill,
  map,
  transpose,
  jsonCodec,
}
/* No side effect */
